// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ChevronUp: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M1.927 15.97c0-.284.115-.541.3-.727l9.009-9a1.027 1.027 0 0 1 1.456 0l9.008 9a1.03 1.03 0 0 1-1.456 1.456l-8.28-8.274-8.28 8.274a1.028 1.028 0 0 1-1.756-.726v-.001l-.001-.001Z" />
  </SvgIcon>
);

ChevronUp.activeColor = 'inherit';
ChevronUp.muiName = 'ChevronUp';
